<template>
  <div class="modal with-outside">
    <!-- v-click-outisde settings for 'modules/directives.js' -->
    <div class="modal-outside modal-small" v-click-outside="closed">
      <div class="title">
        <h3>%</h3>
        <span class="diginity dg-close close" @click="closed"></span>
      </div>
      <div class="body-scroll">
        <!-- content parameter required for static content -->
        <div v-html="static_content(contex)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["type"], // get props from App.vue click params
  data() {
    return {
      selectBody: ""
    };
  },
  methods: {
    closed() {
      // Sends off modal information to App.vue
      this.$emit("closed", undefined);
    }
  },
  computed: {
    ...mapGetters(["static_content"]),
    contex() {
      return this.type;
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/colors";
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  &.with-outside {
    cursor: pointer;
  }
  .modal-outside {
    cursor: default;
    padding: 10px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    max-width: calc(100% - 50px);
    overflow-y: auto;
    max-height: calc(100% - 50px);
    &.modal-small {
      width: 650px;
    }
    .title {
      position: relative;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      h3 {
        margin: 0;
        padding: 10px 20px 10px 10px;
        font-size: 18px;
      }
      .close {
        font-size: 25px;
        margin-right: 5px;
        cursor: pointer;
        &:hover {
          color: red;
        }
      }
    }
  }
}

h3 {
  color: $main;
}
.video-frame {
  position: relative;
  padding-bottom: 56.25%;
  /* 16:9 */
  padding-top: 25px;
  height: 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
